import React from 'react';
import Switch from 'react-switch';
import AmCharts from "@amcharts/amcharts3-react";
import {data, sportColors} from './data';

export default class App extends React.Component {
	constructor(props) {
		super(props);
		this.changeOnSwitch = this.changeOnSwitch.bind(this);
		this.handleRollOver = this.handleRollOver.bind(this);
		this.handleRollOut = this.handleRollOut.bind(this);
	}

	state = {
		withFootball: false,
		map: null
	}

	changeOnSwitch(){
		const { withFootball, map } = this.state;

		map.dataProvider.areas = data.map(country => {
			let value = withFootball ? country.sport : country.sport2;
			country.color = sportColors[value];
			return {...country};
		});

		this.setState(prevState => ({
			withFootball: !prevState.withFootball
		}));

		map.validateData();

		this.mapTitle.innerHTML = "";
	}

	componentDidMount(){
		const { withFootball } = this.state;
		let zoomSpeed = 1;

		if (window.innerWidth < 1000){
			zoomSpeed = 0;
		}

		let map = AmCharts.makeChart( this.map,
			{
				"type": "map",
				"theme": "light",
				"color": "#fff",
				"colorSteps": 10,
				"zoomDuration": zoomSpeed,
				"zoomControl": {
					"homeButtonEnabled": true,
					"buttonFillColor": "#427da5",
					"buttonColorHover": "#325f7d",
					"buttonRollOverColor": "#325f7d"
				},
				"dataProvider": {
					"map": "worldHigh",
					"zoomLevel": 1,
					"zoomLongitude": 10,
					"zoomLatitude": 45,
					"areas": data.map(country => {
						let value = !withFootball ? country.sport : country.sport2;
						country.color = sportColors[value];
						return {...country};
					})
				},
				"export": {
					"enabled": false,
				},
				"areasSettings": {
					"autoZoom": false,
					"selectedColor": undefined,
					"rollOverColor": undefined,
					"unlistedAreasColor": "#615e6b",
					"alpha": 1,
					"unlistedAreasAlpha": 1,
					"balloonText": undefined,
					"outlineColor": "#101d2d",
					"unlistedAreasOutlineColor": "#101d2d",
					"rollOverOutlineColor": "#101d2d",
					"selectedOutlineColor": "#101d2d"
				}
			}

		);

		map.addListener("rollOverMapObject", this.handleRollOver);
		map.addListener("rollOutMapObject", this.handleRollOut);

	  this.setState({map});

	}

	handleRollOver(e){
		if(e.mapObject.title === "United Kingdom" && this.state.withFootball){
			this.mapTitle.innerHTML = `
				<span>England : <span class="sport cricket">Cricket</span></span>
				<span>Wales : <span class="sport rugby">Rugby</span></span>
				<span>Scotland : <span class="sport golf">Golf</span></span>
				<span>Nothern Ireland : <span class="sport golf">Golf</span></span>
			`;
		} else if (e.mapObject.title === "United Kingdom" && !this.state.withFootball){
			this.mapTitle.innerHTML = `
				<span>England : <span class="sport football">Football</span></span>
				<span>Wales : <span class="sport football">Football</span></span>
				<span>Scotland : <span class="sport football">Football</span></span>
				<span>Nothern Ireland : <span class="sport football">Football</span></span>
			`;
		} else {
			this.state.withFootball ?
				this.mapTitle.innerHTML = `${e.mapObject.title} : <span class="sport ${e.mapObject.sport2}">${e.mapObject.sport2}</span>` :
				this.mapTitle.innerHTML = `${e.mapObject.title} : <span class="sport ${e.mapObject.sport}">${e.mapObject.sport}</span>`;
		}
	}

	handleRollOut(e){
		this.mapTitle.innerHTML = '';
	}

	render() {

		return (
			<div className="app">

				{/* Header */}
				<header id="header">
					<div className="container">
						<h1 className="main-title">The World Without Football</h1>
						<p className="title-description">Which sports would rule the world?</p>
					</div>
				</header>
				{/* End of header */}

				{/* Content */}
				<main className="main-content">
					<div className="container">
						<p className="description">There’s nothing quite like the World
						Cup to remind us just how much the world loves football. In
						fact, over 3.2 billion fans tuned in to watch the 2014 World
						Cup, with even more expected to enjoy this years’ event.</p>
						<p className="description">But have you ever wondered which
						sports would rule the world if (heaven forbid) football wasn’t
						around?</p>
						<p className="action-text">
						{ window.innerWidth > 1000 ?
							"Hover on the map below" :
							"Tap on the map below"
						} to see the most searched for sport in every country
						and flick the switch to remove football from the mix.</p>
						<div className="football-switch-wrapp">
							<label
								className={this.state.withFootball ? null : "on" }
								htmlFor="football-switch"
							>With Football</label>
							<Switch
								id='football-switch'
								checkedIcon={false}
								uncheckedIcon={false}
								offColor='#427da5'
								onColor='#427da5'
								className='footballSwitch'
								onChange={this.changeOnSwitch}
								checked={this.state.withFootball ? true : false}
								pos={this.state.withFootball ? 29 : 0}
							/>
							<label
								htmlFor='football-switch'
								className={this.state.withFootball ? "on" : null}
							>Without Football</label>
						</div>
						<div className="all-sports">
							<div className={this.state.withFootball ? "football unvisible" : "football"}>
								<img className="sport-icon" src={require('./assets/football-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Football</span>
							</div>
							<div className="basketball">
								<img className="sport-icon" src={require('./assets/basketball-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Basketball</span>
							</div>
							<div className="cricket">
								<img className="sport-icon" src={require('./assets/cricket-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Cricket</span>
							</div>
							<div className="golf">
								<img className="sport-icon" src={require('./assets/golf-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Golf</span>
							</div>
							<div className="martial-arts">
								<img className="sport-icon" src={require('./assets/martial-arts-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Martial Arts<sup>2</sup></span>
							</div>
							<div className={this.state.withFootball ? "athletics" : "athletics unvisible"}>
								<img className="sport-icon" src={require('./assets/athletics-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Athletics<sup>1</sup></span>
							</div>
							<div className={this.state.withFootball ? "rugby" : "rugby unvisible"}>
								<img className="sport-icon" src={require('./assets/rugby-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Rugby</span>
							</div>
							<div className="baseball">
								<img className="sport-icon" src={require('./assets/baseball-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Baseball</span>
							</div>
							<div className="motorsports">
								<img className="sport-icon" src={require('./assets/motorsports-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Motorsports<sup>3</sup></span>
							</div>
							<div className="other">
								<img className="sport-icon" src={require('./assets/other-icon.svg')} alt="sport-icon" />
								<span className="sport-label">Other<sup>4</sup></span>
							</div>
							<div className="no-data">
								<img className="sport-icon" src={require('./assets/nodata-icon.svg')} alt="sport-icon" />
								<span className="sport-label">No Data</span>
							</div>
						</div>
						<div className="popup-wrapp">
							<div className="popup" ref={el => this.mapTitle = el}></div>
						</div>
						<div
							id="map"
							ref={el => this.map = el}
						></div>
					</div>
				</main>
				{/* End of Content */}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App.js